import { createSelector } from 'reselect';
import { NOT_FOUND } from 'redux-first-router';

const pageTypeSelector = (state) => state.location.type;

export const locationIsPageNotFoundSelector = createSelector(
  [pageTypeSelector],
  (pageType) => pageType === NOT_FOUND,
);
